import { render, staticRenderFns } from "./PreorderExplain.vue?vue&type=template&id=720a4f9f"
import script from "./PreorderExplain.vue?vue&type=script&lang=js"
export * from "./PreorderExplain.vue?vue&type=script&lang=js"
import style0 from "./PreorderExplain.vue?vue&type=style&index=0&id=720a4f9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports